import React, { useState } from 'react';
import './InputField.css';
import { Visibility, VisibilityOff, VisibilityOffOutlined, VisibilityOutlined } from '@mui/icons-material';


const InputField = ({
  type = 'text',
  placeholder = '',
  value = '',
  icon,
  showToggle = false,
  onChange,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const getInputType = () => {
    if (type === 'password') {
      return showPassword ? 'text' : 'password';
    }
    return type;
  };

  return (
    <div className="input-wrapper1">
      <span className="input-icon1">{icon}</span>
      <input
        type={getInputType()}
        placeholder={placeholder}
        defaultValue={value}
        onChange={onChange}
        className="input-field1"
      />
      {type === 'password' && showToggle && (
        <span
          className="input-toggle1"
          onClick={() => setShowPassword(!showPassword)}
        >
          {showPassword ? <VisibilityOffOutlined/> : <VisibilityOutlined/>}
        </span>
      )}
    </div>
  );
};

export default InputField;
